import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import * as RNLocalize from "react-native-localize";

import pl from "locales/pl/translation.json";
import en from "locales/en/translation.json";

const SUPPORTED_LANGUAGES = ["pl", "en"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const LANGUAGE_STORAGE_KEY = "nota.lang";

function detectLanguage(): SupportedLanguage {
  if (typeof window === "undefined") return "en";
  const stored = localStorage.getItem(
    LANGUAGE_STORAGE_KEY,
  ) as SupportedLanguage | null;
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;

  try {
    const locales = RNLocalize.getLocales();
    if (locales.length > 0) {
      const code = locales[0].languageCode as SupportedLanguage;
      if (SUPPORTED_LANGUAGES.includes(code)) return code;
    }
  } catch {
    const code = navigator.language?.split("-")[0] as SupportedLanguage;
    if (SUPPORTED_LANGUAGES.includes(code)) return code;
  }

  return "en";
}

export function changeLanguage(lang: SupportedLanguage): void {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  i18n.changeLanguage(lang);
}

i18n.use(initReactI18next).init({
  resources: {
    pl: { translation: pl },
    en: { translation: en },
  },
  lng: detectLanguage(),
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LANGUAGES,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
